import { DefaultService } from '@/services/DefaultService';


export default class AssClienteMaoDeObraService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}
    find(id){
        return this._http.get(`${this._env}/pro/clientemaodeobra/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    findAllByIdCliente(idcliente, column, situacao, tipoCobranca, tipoAlocacao, limit = 50, page = 0, order = 'asc', ...params) {
        return this._http.get(`${this._env}/pro/clientemaodeobra/findAllByIdCliente/cliente/${idcliente}.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&tipoCobranca=${tipoCobranca}&tipoAlocacao=${tipoAlocacao}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    updateSituacao(obj){
        return this._http.post(`${this._env}/pro/clientemaodeobra/updatesituacao`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    save(obj){
        return this._http.post(`${this._env}/pro/clientemaodeobra`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}